import { Tool } from "ai";
import { useMemo } from "react";
import * as z from "zod";

import { TOOL_CALL_DESCRIPTION_FIELD } from "components/AiChat/constants";
import { Book } from "components/icons/generated";

import useSpaceliftDocsSearch, { DocsSearchResult } from "./useSpaceliftDocsSearch";

const searchDocsInputSchema = z.object({
  [TOOL_CALL_DESCRIPTION_FIELD]: z
    .string()
    .describe(
      "A short, user-friendly description of the action. Examples: 'Searching docs for drift detection', 'Looking up policy configuration', 'Finding setup instructions'"
    ),
  query: z.string().describe("Search query to find relevant Spacelift documentation"),
  limit: z.number().optional().describe("Number of results to return (default: 5)"),
});

type SearchDocsInput = z.infer<typeof searchDocsInputSchema>;
type SearchDocsOutput = { results: DocsSearchResult[] };

export const toolIcon = Book;

const useSearchDocsTool = (): Tool<SearchDocsInput, SearchDocsOutput> => {
  const { searchDocs } = useSpaceliftDocsSearch();

  return useMemo(
    () => ({
      title: "Searching documentation",
      description:
        "Search the Spacelift documentation. Use this to find relevant docs pages about Spacelift features, concepts, and configuration.",
      inputSchema: searchDocsInputSchema,
      execute: async ({ query, limit }) => {
        const results = searchDocs({ query, limit });
        return { results };
      },
    }),
    [searchDocs]
  );
};

export default useSearchDocsTool;
